import { GrayImage3 } from './../../image-slice-show/share/image';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import {
  ImageHead,
  LocalImageLoaderService,
} from './local-image-loader.service';

@Component({
  selector: 'app-local-image-loader',
  templateUrl: './local-image-loader.component.html',
  styleUrls: ['./local-image-loader.component.css'],
  providers: [LocalImageLoaderService],
})
export class LocalImageLoaderComponent implements OnInit {
  isHeadLoaded = false;
  isImageLoaded = false;
  imageHead: ImageHead | undefined;
  imageFile: Blob | undefined;

  @Output() imageLoad = new EventEmitter<GrayImage3>();

  constructor(private loaderService: LocalImageLoaderService) {}

  ngOnInit() {}

  loadLocalImage() {
    if (this.imageHead === undefined || this.imageFile === undefined) {
      throw Error('Head or imageFile is undefined');
    }
    this.loaderService
      .loadImage(this.imageFile, this.imageHead)
      .subscribe(
        (image) => this.imageLoad.emit(image),
        (e) => console.error(e),
      );
  }

  markImageLoaded(files: FileList) {
    this.imageFile = files[0];
    this.isImageLoaded = true;
  }

  markHeadLoaded(head: FileList) {
    this.loaderService.loadHead(head[0]).subscribe({
      next: (h) => {
        this.imageHead = h;
        this.isHeadLoaded = true;
      },
      error: (e) => console.log(e),
    });
  }
}
